import angular from 'angular';
import { TipoBeneficiosEnum } from './beneficios.enum';
import { IBeneficioHistorico, IBeneficioTrabalhador } from './model/beneficios.model';
import { IInclusaoBeneficio, IInclusaoBeneficioGet, IInclusaoBeneficioSave } from './model/inclusao.model';
import { ICancelamentoBeneficio, ICancelamentoBeneficioGet, ICancelamentoBeneficioSave } from './model/cancelamento.model';
import { ISuspensaoBeneficio, ISuspensaoBeneficioGet, ISuspensaoBeneficioSave } from './model/suspensao.model';
import { IProrrogacaoBeneficio, IProrrogacaoBeneficioGet, IProrrogacaoBeneficioSave } from './model/prorrogacao.model';
import { ITrocaBeneficio, ITrocaBeneficioGet, ITrocaBeneficioSave } from './model/troca.model';
import { IReativacaoBeneficio, IReativacaoBeneficioGet, IReativacaoBeneficioSave } from './model/reativacao.model';

export class MeurhBeneficiosService {
    static $inject = ['$http', '$rootScope', '$q', 'nsjRouting'];

    public loading_deferred: angular.IDeferred<unknown>;

    constructor(
        public $http: angular.IHttpService,
        public $rootScope: angular.IScope,
        public $q: angular.IQService,
        public nsjRouting: any,
    ) { }

    getTiposBeneficios(empresa: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<TipoBeneficiosEnum[]>, reject) => {
            this.$http.get<TipoBeneficiosEnum[]>(
                this.nsjRouting.generate('persona_beneficios_buscatiposbeneficiosdistintos', {
                    empresa
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('persona_beneficios_buscatiposbeneficiosdistintos_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('persona_beneficios_buscatiposbeneficiosdistintos_error', response);
                reject(response);
            });
        });
    }

    getBeneficiosTrabalhador(trabalhador: string, tipobeneficiointerno?: number) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IBeneficioTrabalhador[]>, reject) => {
            this.$http.get<IBeneficioTrabalhador[]>(
                this.nsjRouting.generate('beneficiostrabalhadores_index', {
                    trabalhador,
                    ...(tipobeneficiointerno !== undefined && { tipobeneficiointerno })
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('beneficiostrabalhadores_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('beneficiostrabalhadores_index_error', response);
                reject(response);
            });
        });
    }

    getHistoricoBeneficiosTrabalhador(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IBeneficioHistorico[]>, reject) => {
            this.$http.get<IBeneficioHistorico[]>(
                this.nsjRouting.generate('beneficiostrabalhadoresadesoes_historico', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('beneficiostrabalhadoresadesoes_historico_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('beneficiostrabalhadoresadesoes_historico_error', response);
                reject(response);
            });
        });
    }

    getInclusoesBeneficio(trabalhador: string, situacao?: number, tipobeneficiointerno?: number) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IInclusaoBeneficio[]>, reject) => {
            this.$http.get<IInclusaoBeneficio[]>(
                this.nsjRouting.generate('meurh_solicitacoesinclusaobeneficios_index', {
                    trabalhador,
                    ...(situacao !== undefined && { situacao }),
                    ...(tipobeneficiointerno !== undefined && { tipobeneficiointerno })
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesinclusaobeneficios_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesinclusaobeneficios_index_error', response);
                reject(response);
            });
        });
    }

    getInclusaoBeneficio(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IInclusaoBeneficioGet>, reject) => {
            this.$http.get<IInclusaoBeneficioGet>(
                this.nsjRouting.generate('meurh_solicitacoesinclusaobeneficios_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesinclusaobeneficios_get_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesinclusaobeneficios_get_error', response);
                reject(response);
            });
        });
    }

    saveInclusaoBeneficio(entity: IInclusaoBeneficioSave) {
        this.loading_deferred = this.$q.defer();
		return this.$q((resolve: angular.IQResolveReject<IInclusaoBeneficioGet>, reject) => {
			this.$http.post<IInclusaoBeneficioGet>(
				this.nsjRouting.generate('meurh_solicitacoesinclusaobeneficios_create', {}, true), entity, {
				timeout: this.loading_deferred.promise
			})
			.then((response) => {
				this.$rootScope.$broadcast('meurh_solicitacoesinclusaobeneficios_create_loaded', response.data);
				resolve(response.data);
			})
			.catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesinclusaobeneficios_create_error', response);
				reject(response);
			});
		});
    }

    getCancelamentosBeneficio(trabalhador: string, situacao?: number) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<ICancelamentoBeneficio[]>, reject) => {
            this.$http.get<ICancelamentoBeneficio[]>(
                this.nsjRouting.generate('meurh_solicitacoescancelamentobeneficios_index', {
                    trabalhador,
                    ...(situacao !== undefined && { situacao })
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoescancelamentobeneficios_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoescancelamentobeneficios_index_error', response);
                reject(response);
            });
        });
    }

    getCancelamentoBeneficio(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<ICancelamentoBeneficioGet>, reject) => {
            this.$http.get<ICancelamentoBeneficioGet>(
                this.nsjRouting.generate('meurh_solicitacoescancelamentobeneficios_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoescancelamentobeneficios_get_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoescancelamentobeneficios_get_error', response);
                reject(response);
            });
        });
    }

    saveCancelamentoBeneficio(entity: ICancelamentoBeneficioSave) {
        this.loading_deferred = this.$q.defer();
		return this.$q((resolve: angular.IQResolveReject<ICancelamentoBeneficioGet>, reject) => {
			this.$http.post<ICancelamentoBeneficioGet>(
				this.nsjRouting.generate('meurh_solicitacoescancelamentobeneficios_create', {}, true), entity, {
				timeout: this.loading_deferred.promise
			})
			.then((response) => {
				this.$rootScope.$broadcast('meurh_solicitacoescancelamentobeneficios_create_loaded', response.data);
				resolve(response.data);
			})
			.catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoescancelamentobeneficios_create_error', response);
				reject(response);
			});
		});
    }

    getSuspensoesBeneficio(trabalhador: string, situacao?: number) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<ISuspensaoBeneficio[]>, reject) => {
            this.$http.get<ISuspensaoBeneficio[]>(
                this.nsjRouting.generate('meurh_solicitacoessuspensaobeneficios_index', {
                    trabalhador,
                    ...(situacao !== undefined && { situacao })
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoessuspensaobeneficios_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoessuspensaobeneficios_index_error', response);
                reject(response);
            });
        });
    }

    getSuspensaoBeneficio(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<ISuspensaoBeneficioGet>, reject) => {
            this.$http.get<ISuspensaoBeneficioGet>(
                this.nsjRouting.generate('meurh_solicitacoessuspensaobeneficios_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoessuspensaobeneficios_get_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoessuspensaobeneficios_get_error', response);
                reject(response);
            });
        });
    }

    saveSuspensaoBeneficio(entity: ISuspensaoBeneficioSave) {
        this.loading_deferred = this.$q.defer();
		return this.$q((resolve: angular.IQResolveReject<ISuspensaoBeneficioGet>, reject) => {
			this.$http.post<ISuspensaoBeneficioGet>(
				this.nsjRouting.generate('meurh_solicitacoessuspensaobeneficios_create', {}, true), entity, {
				timeout: this.loading_deferred.promise
			})
			.then((response) => {
				this.$rootScope.$broadcast('meurh_solicitacoessuspensaobeneficios_create_loaded', response.data);
				resolve(response.data);
			})
			.catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoessuspensaobeneficios_create_error', response);
				reject(response);
			});
		});
    }

    getProrrogacoesBeneficio(trabalhador: string, situacao?: number) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IProrrogacaoBeneficio[]>, reject) => {
            this.$http.get<IProrrogacaoBeneficio[]>(
                this.nsjRouting.generate('meurh_solicitacoesprorrogacaosuspensaobeneficios_index', {
                    trabalhador,
                    ...(situacao !== undefined && { situacao })
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesprorrogacaosuspensaobeneficios_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesprorrogacaosuspensaobeneficios_index_error', response);
                reject(response);
            });
        });
    }

    getProrrogacaoBeneficio(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IProrrogacaoBeneficioGet>, reject) => {
            this.$http.get<IProrrogacaoBeneficioGet>(
                this.nsjRouting.generate('meurh_solicitacoesprorrogacaosuspensaobeneficios_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesprorrogacaosuspensaobeneficios_get_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesprorrogacaosuspensaobeneficios_get_error', response);
                reject(response);
            });
        });
    }

    saveProrrogacaoBeneficio(entity: IProrrogacaoBeneficioSave) {
        this.loading_deferred = this.$q.defer();
		return this.$q((resolve: angular.IQResolveReject<IProrrogacaoBeneficioGet>, reject) => {
			this.$http.post<IProrrogacaoBeneficioGet>(
				this.nsjRouting.generate('meurh_solicitacoesprorrogacaosuspensaobeneficios_create', {}, true), entity, {
				timeout: this.loading_deferred.promise
			})
			.then((response) => {
				this.$rootScope.$broadcast('meurh_solicitacoesprorrogacaosuspensaobeneficios_create_loaded', response.data);
				resolve(response.data);
			})
			.catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesprorrogacaosuspensaobeneficios_create_error', response);
				reject(response);
			});
		});
    }

    getTrocasBeneficio(trabalhador: string, situacao?: number) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<ITrocaBeneficio[]>, reject) => {
            this.$http.get<ITrocaBeneficio[]>(
                this.nsjRouting.generate('meurh_solicitacoestrocabeneficios_index', {
                    trabalhador,
                    ...(situacao !== undefined && { situacao })
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoestrocabeneficios_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoestrocabeneficios_index_error', response);
                reject(response);
            });
        });
    }

    getTrocaBeneficio(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<ITrocaBeneficioGet>, reject) => {
            this.$http.get<ITrocaBeneficioGet>(
                this.nsjRouting.generate('meurh_solicitacoestrocabeneficios_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoestrocabeneficios_get_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoestrocabeneficios_get_error', response);
                reject(response);
            });
        });
    }

    saveTrocaBeneficio(entity: ITrocaBeneficioSave) {
        this.loading_deferred = this.$q.defer();
		return this.$q((resolve: angular.IQResolveReject<ITrocaBeneficioGet>, reject) => {
			this.$http.post<ITrocaBeneficioGet>(
				this.nsjRouting.generate('meurh_solicitacoestrocabeneficios_create', {}, true), entity, {
				timeout: this.loading_deferred.promise
			})
			.then((response) => {
				this.$rootScope.$broadcast('meurh_solicitacoestrocabeneficios_create_loaded', response.data);
				resolve(response.data);
			})
			.catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoestrocabeneficios_create_error', response);
				reject(response);
			});
		});
    }

    getReativacoesBeneficio(trabalhador: string, situacao?: number) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IReativacaoBeneficio[]>, reject) => {
            this.$http.get<IReativacaoBeneficio[]>(
                this.nsjRouting.generate('meurh_solicitacoesreativacaobeneficios_index', {
                    trabalhador,
                    ...(situacao !== undefined && { situacao })
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesreativacaobeneficios_index_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesreativacaobeneficios_index_error', response);
                reject(response);
            });
        });
    }

    getReativacaoBeneficio(id: string) {
        this.loading_deferred = this.$q.defer();
        return this.$q((resolve: angular.IQResolveReject<IReativacaoBeneficioGet>, reject) => {
            this.$http.get<IReativacaoBeneficioGet>(
                this.nsjRouting.generate('meurh_solicitacoesreativacaobeneficios_get', {
                    id
                }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesreativacaobeneficios_get_loaded', response.data);
                resolve(response.data);
            })
            .catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesreativacaobeneficios_get_error', response);
                reject(response);
            });
        });
    }

    saveReativacaoBeneficio(entity: IReativacaoBeneficioSave) {
        this.loading_deferred = this.$q.defer();
		return this.$q((resolve: angular.IQResolveReject<IReativacaoBeneficioGet>, reject) => {
			this.$http.post<IReativacaoBeneficioGet>(
				this.nsjRouting.generate('meurh_solicitacoesreativacaobeneficios_create', {}, true), entity, {
				timeout: this.loading_deferred.promise
			})
			.then((response) => {
				this.$rootScope.$broadcast('meurh_solicitacoesreativacaobeneficios_create_loaded', response.data);
				resolve(response.data);
			})
			.catch((response) => {
                this.$rootScope.$broadcast('meurh_solicitacoesreativacaobeneficios_create_error', response);
				reject(response);
			});
		});
    }
}
